import enLocale from 'date-fns/locale/en-US';
import eeLocale from 'date-fns/locale/et';
import roLocale from 'date-fns/locale/ro';
import ruLocale from 'date-fns/locale/ru';
import uaLocale from 'date-fns/locale/uk';

export const localeMap = {
    ua: uaLocale,
    en: enLocale,
    ru: ruLocale,
    ee: eeLocale,
    ro: roLocale,
};
